import React, { createContext, useContext, useState, ReactNode } from "react";
import type OrderItem from "../models/OrderItem";

// export interface CartItem extends OrderItem {
//   quantity: number;
// }


interface CartContextType {
  cart: OrderItem[];
  toggleCart: (item: OrderItem) => void;
  updateQuantity: (id: string, quantity: number) => void;
  removeFromCart: (id: string) => void;
  clearCart: () => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider = ({ children }: { children: ReactNode }) => {
  const [cart, setCart] = useState<OrderItem[]>([]);

  // Add/remove item (toggle)
  const toggleCart = (item: OrderItem) => {
    setCart((prevCart) => {
      const exists = prevCart.find((ci) => ci.id === item.id);
      if (exists) {
        // remove
        return prevCart.filter((ci) => ci.id !== item.id);
      } else {
        // add with quantity 1
        return [...prevCart, { ...item, quantity: 1 }];
      }
    });
  };

  // Update quantity
  const updateQuantity = (id: string, quantity: number) => {
    setCart((prevCart) =>
      prevCart.map((ci) => (ci.id === id ? { ...ci, quantity } : ci))
    );
  };

  // Remove specific item
  const removeFromCart = (id: string) => {
    setCart((prevCart) => prevCart.filter((ci) => ci.id !== id));
  };

  const clearCart = () => setCart([]);

  return (
    <CartContext.Provider
      value={{ cart, toggleCart, updateQuantity, removeFromCart, clearCart }}
    >
      {children}
    </CartContext.Provider>
  );
};

// Custom hook
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context)
    throw new Error("useCart must be used inside CartProvider");
  return context;
};